import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Dashboard from '../src/Dashboard';
import Footer from '../src/footer';

class App extends Component {
  render() {
    return (
      <div>
        <Dashboard />
        <Footer />
      </div>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('root'));